// SupplierStepper.jsx
import React, { useState } from 'react';
import SupplierForm from './SupplierForm'; 
import SupplierAddressForm from './SupplierAddressForm';
import CertificateForm from './CertificateForm';
import WarehouseForm from './WarehouseForm';
import Header from '../components/SHeader';
import Footer from '../components/SFooter';

import SupplierJoinPromo from '../components/SupplierJoinPromo';

import { Button, Stepper, Step, StepLabel } from '@mui/material';

const steps = ['Supplier Info', 'Addresses', 'Certificates', 'Warehouses'];

export default function SupplierStepper() {
  const [activeStep, setActiveStep] = useState(0);
  const [supplierData, setSupplierData] = useState({
    supplierName: '',
    email: '',
    phone: '',
    contactPerson: '',
    gstNumber: '',
    panNumber: '',
    website: '',
    companyTypeId: '',
    addresses: [], 
    certificates: [],
    warehouses: [],
  });

  const handleNext = () => setActiveStep(prev => prev + 1);
  const handleBack = () => setActiveStep(prev => prev - 1);

  const updateData = (key, value) => {
    setSupplierData(prev => ({ ...prev, [key]: value }));
  };

  const stepsComponents = [
    <SupplierForm data={supplierData} updateData={updateData} handleNext={handleNext} />,
    <SupplierAddressForm data={supplierData.addresses} updateData={value => updateData('addresses', value)} handleNext={handleNext} handleBack={handleBack} />,
    <CertificateForm data={supplierData.certificates} updateData={value => updateData('certificates', value)} handleNext={handleNext} handleBack={handleBack} />,
    <WarehouseForm data={supplierData.warehouses} updateData={value => updateData('warehouses', value)} handleBack={handleBack} finalSubmitData={supplierData} />
  ];

  return (
      <>
    <Header />
      
    <div className="p-4">
      <Stepper activeStep={activeStep} alternativeLabel>
        {steps.map(label => (
          <Step key={label}><StepLabel>{label}</StepLabel></Step>
        ))}
      </Stepper>
      <div className="mt-6">{stepsComponents[activeStep]}</div>
    </div>

<SupplierJoinPromo />

   <Footer />
          </>
  );
}